import React, { memo } from "react";

import { Button, Grid, Box } from "@mui/material";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { isMobile } from "react-device-detect";

import useStyles from "../Lobby/Lobby.styles";
import FavoriteButton from "../Lobby/FavoriteButton/FavoriteButton";
import CustomImg from "../../CustomImg";

const Game = ({
  thumbnailUrl,
  name,
  gameId = null,
  providerName = null,
  categoryName = null,
  gameTag = null,
  isFavorite = null,
  recallFav = null,
  onGameClick = null
}) => {
  const { metamaskLoggedIn, isLoggedIn } = useSelector(
    (state) => state.authentication
  );
  const navigate = useNavigate();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleGameLaunch = () => {
    // Call the onGameClick callback if provided
    if (onGameClick) {
      onGameClick();
    }

    if (!(metamaskLoggedIn || isLoggedIn)) {
      toast.error(t("GAME.GAME_LOGIN_MSG"), {
        id: "GAME_LOGIN_MSG"
      });
      return;
    }
    navigate(`/game/${gameId}`);
  };

  return (
    <Grid item spacing={2}>
      <Grid className={`${classes.casinoCard} favCard`}>
        <Box className="imgBox">
          <Box>
            <CustomImg
              origSrc={thumbnailUrl || "/images/game-default.webp"}
              tempSrc={"/images/game-default.webp"}
            />
          </Box>
          <FavoriteButton
            isFavorite={isFavorite}
            favBtnClass={classes.favIconWrap}
            gameId={gameId}
            recallFav={recallFav}
          />
          <Box className="squareBox"></Box>
          <Box className="playBtnBox">
            <Button
              type="button"
              className="playBtn"
              onClick={() => handleGameLaunch()}
            >
              <svg viewBox="0 0 384 512">
                <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" />
              </svg>
              <span className="text">{t("GAME.PLAY_NOW")}</span>
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default memo(Game);
